import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import propertyCountActions from '../actions/propertyCount';

function updatePropertyCountInfo(store, action) {
    const propertyCountInfo = action.payload.propertyCountInfo;

    request.post(`/${config.url_prefix}/api/updatePropertyCountInfo`)
        .send({
            data: propertyCountInfo
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(propertyCountActions.alertError(errorKey));
            } else if (response.statusCode === 204) {
                store.dispatch(actions.changeAppState('SOFTWARE_DETAILS'));
            } else {
                const errorKey = 'ipmob.error.process.request';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(propertyCountActions.alertError(errorKey));
            }
        });
}

export default updatePropertyCountInfo;
